import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import BrandLogo from '../components/BrandLogo';
import { toast } from 'sonner';

const AdminLogin = () => {
  const { login, admin } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: 'verardonicola@gmail.com', password: '' });
  const [busy, setBusy] = useState(false);

  React.useEffect(() => { if (admin) nav('/admin', { replace: true }); }, [admin, nav]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await login(form); toast.success('Benvenuto Nicola'); nav('/admin'); }
    catch (err) { toast.error(err?.response?.data?.detail || err.message || 'Errore'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0D] text-white flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-[#C9A961]/10 rounded-full blur-3xl" />
      <Link to="/" className="absolute top-6 left-6 flex items-center gap-2 text-slate-400 hover:text-white transition text-sm">
        <ArrowLeft className="w-4 h-4" /> Torna alla home
      </Link>

      <form onSubmit={submit} className="relative z-10 w-full max-w-md bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur">
        <div className="mb-6">
          <BrandLogo size="md" />
        </div>
        <h1 className="font-display text-3xl mb-2">Area riservata</h1>
        <p className="text-slate-400 text-sm mb-6">Accesso esclusivo per l'amministratore.</p>

        <label className="block mb-4">
          <span className="text-xs text-slate-300">Email</span>
          <div className="mt-1 flex items-center gap-2 bg-black/40 border border-white/10 rounded-xl px-3 py-2.5 focus-within:border-[#C9A961]">
            <Mail className="w-4 h-4 text-slate-400" />
            <input type="email" required value={form.email} onChange={e=>setForm({...form, email: e.target.value})} className="flex-1 outline-none bg-transparent text-white" />
          </div>
        </label>
        <label className="block mb-6">
          <span className="text-xs text-slate-300">Password</span>
          <div className="mt-1 flex items-center gap-2 bg-black/40 border border-white/10 rounded-xl px-3 py-2.5 focus-within:border-[#C9A961]">
            <Lock className="w-4 h-4 text-slate-400" />
            <input type="password" required value={form.password} onChange={e=>setForm({...form, password: e.target.value})} className="flex-1 outline-none bg-transparent text-white" placeholder="la tua password" />
          </div>
        </label>

        <button disabled={busy} className="w-full inline-flex items-center justify-center gap-2 bg-[#C9A961] hover:bg-white text-black font-semibold px-4 py-2.5 rounded-full transition">
          {busy ? 'Accesso...' : 'Accedi'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
